import { useEffect, useRef, useState } from "react";
import "./InvoiceAdminContainer.scss";
import "./InvoiceAdminPanel.scss";
import { BellRed, BellWhite, InvoicesLeftTooltip, SearchIcon } from "assets/Imports";
import { InvoiceAdmincard } from "./InvoiceAdminCard";
import { InvoiceData, getAllInvoices, invoicesLeftCount, pendingInvoicesCount } from "@services/InvoiceServices";
import useInvoices from "./useInvoices";
import { RejectInvoiceModal } from "./RejectInvoiceModal";
import RequestInvoiceModal from "./RequestInvoiceModal";
import { getDocs, updateDoc, limit, collection, where, doc, query } from "firebase/firestore";
import toast, { Toaster } from "react-hot-toast";
import useCollaboratorLogs from "@hooks/collaborators/useCollaboratorLogs";
import { db } from "initFirebase";
import { CustomSpinner } from "@components/Spinner/SpinnerMyAccountView";
export default function InvoiceAdminContainer({ user }) {
	const [requestInvoiceModal, setRequestInvoiceModal] = useState<boolean>(false);
	const [pendingInvoices, setPendingInvoices] = useState<number>(0);
	const [categorie, setCategorie] = useState<number>(1);
	const {
		invoices,
		filterInvoices,
		getInvoices,
		invoiceSearch,
		acceptInvoice,
		addGeneration,
		downloadInvoice,
		cancelInvoice,
		rejectInvoice,
		cancelationValidation,
		sendRejectEmail,
		deleteInvoiceById,
		loading,
	} = useInvoices();

	const { invoiceLog } = useCollaboratorLogs();
	const [invoicesLeft, setInvoicesLeft] = useState<number>();
	const [invoiceToReject, setInvoiceToReject] = useState<InvoiceData>();
	const [rejectInvoiceModal, setRejectInvoiceModal] = useState<boolean>();

	const childRefs = useRef([]);

	const getPendingInvoicesCount = async () => {
		let tempPendingInvoicesCount: number = await pendingInvoicesCount();
		setPendingInvoices(tempPendingInvoicesCount);
	};

	const handleCategorieChange = (cat: number) => {
		setCategorie(cat);
	};
	const getInvoicesLeft = async () => {
		let tempInvoicesLeft = await invoicesLeftCount();
		setInvoicesLeft(tempInvoicesLeft);
	};

	const setContactNotificationSeen = async (contactInfoId) => {
		// When answering a contact message, the notification associated with the contact is set as seen.
		try {
			const q = query(collection(db, "notifications"), where("invoiceFbId", "==", contactInfoId), limit(1));
			const querySnapshot = await getDocs(q);
			let contactNotificationId = querySnapshot.docs[0].id ?? "";
			const docRef = doc(db, "notifications", contactNotificationId);
			await updateDoc(docRef, {
				seen: true,
				check: true,
			});
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		filterInvoices(categorie);
	}, [categorie, pendingInvoices]);

	useEffect(() => {
		getPendingInvoicesCount();
		getInvoices();
		getInvoicesLeft();
	}, []);

	useEffect(() => {
		getPendingInvoicesCount();
	}, [invoices]);

	return (
		<>
			<div className="invoice-admin-main-container">
				<Toaster />
				<RequestInvoiceModal
					show={requestInvoiceModal}
					onHide={() => setRequestInvoiceModal(false)}
					getInvoices={getInvoices}
					setCategorie={setCategorie}
					collaborator={user}
				/>
				<div className="fac-header">
					<div className="fac-title">
						<h1>Facturación</h1>
						<span className="fac-count" title="Solicitudes pendientes">
							{pendingInvoices} {pendingInvoices === 1 ? "pendiente" : "pendientes"}
						</span>
						<p className="fac-note">Las facturas canceladas están en la pestaña «Todas».</p>
					</div>
					<div className="fac-actions">
						<div className="fac-search">
							<img src={SearchIcon} alt="" />
							<input placeholder="Buscar por nombre, matrícula, correo o generación" onChange={invoiceSearch} />
						</div>
						<button type="button" className="fac-new" onClick={() => setRequestInvoiceModal(true)}>
							+ Nueva solicitud
						</button>
					</div>
				</div>
				<div className="fac-tabs" role="tablist">
					{[
						[1, "Todas"],
						[2, "Solicitudes"],
						[3, "Aceptadas"],
						[4, "Rechazadas"],
						[5, "Autogeneradas"],
					].map(([cat, label]) => (
						<button
							key={cat}
							type="button"
							role="tab"
							aria-selected={categorie === cat}
							className={"fac-tab" + (categorie === cat ? " on" : "")}
							onClick={() => handleCategorieChange(cat as number)}
						>
							{label}
							{cat === 2 && pendingInvoices > 0 && <span className="fac-badge">{pendingInvoices}</span>}
						</button>
					))}
					{/* Se canceló la utilizacion de la cagetoria siguiente >>> */}
					{/* <button
						className={"invoice-type-selector " + (categorie === 6 ? "active" : "")}
						onClick={() => handleCategorieChange(6)}
					>
						<p>Facturas Generadas</p>
					</button> */}
				</div>
				{loading && <CustomSpinner height={400} size={100} borderSize={5} />}
				{!loading &&
					invoices?.map((invoice: InvoiceData, index) => {
						return (
							<InvoiceAdmincard
								invoice={invoice}
								key={"invoice-card-" + invoice.id}
								cat={categorie}
								acceptInvoice={acceptInvoice}
								addGeneration={addGeneration}
								downloadInvoice={downloadInvoice}
								cancelInvoice={cancelInvoice}
								setRejectInvoiceModal={setRejectInvoiceModal}
								setInvoiceToReject={setInvoiceToReject}
								cancelationValidation={cancelationValidation}
								setContactNotificationSeen={setContactNotificationSeen}
								getInvoices={getInvoices}
								setCategorie={setCategorie}
								deleteInvoiceById={deleteInvoiceById}
								collaborator={user}
								invoiceLog={invoiceLog}
							></InvoiceAdmincard>
						);
					})}
				<RejectInvoiceModal
					show={rejectInvoiceModal}
					onHide={() => setRejectInvoiceModal(false)}
					invoice={invoiceToReject}
					rejectInvoice={rejectInvoice}
					sendRejectEmail={sendRejectEmail}
					collaborator={user}
				/>
			</div>
			<div className="remaining-invoices-indicator">
				<img src={BellRed} alt="Icono de facturas restantes"></img>
				<span>{invoicesLeft}</span>
			</div>
			<div className="remaining-invoices-indicator-2">
				<div className="invoices-left-tooltip">
					Timbres restantes en este periodo. <br />
					Fecha de renovación: 8 de cada mes.
				</div>
				<img src={BellWhite} alt="Icono de facturas restantes"></img>
				<span>{invoicesLeft}</span>
			</div>
		</>
	);
}
